import { render } from "./AmazonAdvertisingPage.vue?vue&type=template&id=dce4d990&scoped=true"
import script from "./AmazonAdvertisingPage.vue?vue&type=script&lang=js"
export * from "./AmazonAdvertisingPage.vue?vue&type=script&lang=js"

import "./AmazonAdvertisingPage.vue?vue&type=style&index=0&id=dce4d990&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce4d990"]])

export default __exports__